import * as React from 'react';
import { SlideContext } from '../../../../utils/slideContext';
import { useSlideContextBuilder } from '../../../../utils/useSlideContextBuilder';
import * as styles from './Slide.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var Slide = /*#__PURE__*/React.memo(function Slide(_ref) {
  var index = _ref.index,
      width = _ref.width,
      children = _ref.children,
      marginLeft = _ref.marginLeft,
      marginRight = _ref.marginRight;
  var slideContext = useSlideContextBuilder(index);
  return /*#__PURE__*/_jsx(SlideContext.Provider, {
    value: slideContext,
    children: /*#__PURE__*/_jsx("li", {
      className: styles['container'],
      style: {
        width: width
      },
      children: /*#__PURE__*/_jsx("div", {
        className: styles['content-wrapper'],
        style: {
          marginLeft: marginLeft,
          marginRight: marginRight
        },
        children: children
      })
    })
  });
});